<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn>
				<v-btn color="white" text @click="$router.push({ name: 'standard_cost_index' })">
					<v-icon class="mr-1">mdi-clipboard-list-outline</v-icon>
					標準原価一覧
				</v-btn>
			</template>
			<CostSearchSection
				:query="q"
				:categories="categories"
				@search-infos="searchOrderIndividualInfos($event)"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="order_individual_infos"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr
							:class="authority_flag ? '' : 'no-click'"
							@click="authority_flag ? openDialog(item) : false"
						>
							<td>
								{{ item.full_product_number }}
							</td>
							<td v-if="item && item.ordered_product && item.ordered_product.product">
								{{ item.ordered_product.product.product_code }}
							</td>
							<td v-else-if="item && item.matter_product && item.matter_product.product">
								{{ item.matter_product.product.product_code }}
							</td>
							<td v-if="item && item.ordered_product && item.ordered_product.product">
								{{ item.ordered_product.product.name }}
							</td>
							<td v-else-if="item && item.matter_product && item.matter_product.product">
								{{ item.matter_product.product.name }}
							</td>
							<td>
								{{ item.quantity }}
							</td>

							<td>{{ Number(totalPrice(item, "plan")).toLocaleString() }}</td>
							<td>{{ Number(totalPrice(item, "actual")).toLocaleString() }}</td>

							<template v-for="category in cost_categories">
								<td v-if="category.required_plan" :key="`planned-${category.id}`">
									{{ Number(costByCategory(item, category, "plan")).toLocaleString() }}
								</td>
								<td :key="`actual-${category.id}`">
									{{ Number(costByCategory(item, category, "actual")).toLocaleString() }}
								</td>
							</template>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<CostEditDialog
			v-if="authority_flag"
			:dialog.sync="dialog"
			:selectedOrderIndividualInfo="selectedOrderIndividualInfo"
			:orderIndividualInfos="order_individual_infos"
			:authorityFlag="authority_flag"
			:costCategories="cost_categories"
			@reload-index="fetchOrderIndividualInfos(q, pagination.current)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import CostEditDialog from "./components/CostEditDialog.vue"
import CostSearchSection from "./components/CostSearchSection.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		CostEditDialog,
		CostSearchSection,
	},
	data() {
		return {
			title: "原価一覧",
			order_individual_infos: [],
			authority_flag: false,
			categories: [],
			headers: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				delivery_info_planned_shipping_date_lteq: null,
				delivery_info_planned_shipping_date_gteq: null,
				ordered_product_product_number_cont: null,
				ordered_product_product_product_category_id_eq: null,
				ordered_product_product_product_code_cont: null,
				ordered_product_product_name_cont: null,
			},
			selectedOrderIndividualInfo: null,
			dialog: false,
			cost_categories: [],
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchOrderIndividualInfos(this.q, page, true)
	},
	methods: {
		createHeaders(cost_categories) {
			const headersArr = [
				{
					text: "製造番号 ",
					value: "ordered_product_product_number",
					width: "200px",
				},
				{
					text: "製品番号",
					value: "product_code",
					width: "200px",
				},
				{
					text: "製品名",
					value: "name",
					width: "200px",
				},
				{
					text: "数量",
					value: "quantity",
					width: "80px",
				},
				{
					text: "合計額(予)",
					value: "total_cost",
					width: "100px",
				},
				{
					text: "合計額(実)",
					value: "total_cost",
					width: "100px",
				},
			]

			cost_categories.forEach((category) => {
				if (category.required_plan) {
					headersArr.push({
						text: category.name + "(予)",
						value: "planned_" + category.name.toLowerCase().replace(" ", "_"),
						width: "100px",
					})
					headersArr.push({
						text: category.name + "(実)",
						value: category.name.toLowerCase().replace(" ", "_"),
						width: "100px",
					})
				} else {
					headersArr.push({
						text: category.name,
						value: category.name.toLowerCase().replace(" ", "_"),
						width: "100px",
					})
				}
			})
			return headersArr
		},

		fetchOrderIndividualInfos(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/costs", {
					params,
					headers,
				})
				.then((response) => {
					this.order_individual_infos = this.setOrderIndividualInfos(
						response.data.order_individual_infos
					)
					this.pagination = response.data.pagination
					if (first_visit) {
						this.categories = response.data.categories
						this.authority_flag = response.data.authority_flag
						this.cost_categories = response.data.cost_categories
						this.headers = this.createHeaders(this.cost_categories)
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setOrderIndividualInfos(orderIndividualInfos) {
			return orderIndividualInfos.map((orderIndividualInfo) => {
				return orderIndividualInfo
			})
		},
		openDialog(item) {
			this.selectedOrderIndividualInfo = item
			this.dialog = true
		},
		getPage(page) {
			this.fetchOrderIndividualInfos(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchOrderIndividualInfos(q) {
			this.q = q
			this.fetchOrderIndividualInfos(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		totalPrice(item, type) {
			const categories =
				type == "plan"
					? this.cost_categories.filter((category) => category.required_plan)
					: this.cost_categories
			return categories.reduce((total, category) => {
				total += this.costByCategory(item, category, type)
				return total
			}, 0)
		},

		costByCategory(order_individual_info, category, type = "actual") {
			const cost = order_individual_info.costs.find((cost) => cost.cost_type == type)
			const priceByCostCategory = cost.cost_item_prices.filter(
				(item_price) => item_price.cost_item.cost_category_id == category.id
			)
			const totalCost = priceByCostCategory.reduce((total, item_price) => {
				total += item_price.price
				return total
			}, 0)
			return totalCost
		},
	},
}
</script>
